import { PageLayoutMui as PageLayout } from '@spotify/confidence-core-react';
import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

import { AuthDebug } from '../AuthDebug';

const DebugPageComponent = () => {
  return (
    <PageLayout title="Debug">
      <AuthDebug />
    </PageLayout>
  );
};

export const DebugPage = withPageImpression(DebugPageComponent, {
  pageId: 'debug',
});
